var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('select-wrapper',{attrs:{"options":_vm.bundles,"placeholder":"Selecteer de bundel waaruit de datasets geimporteerd moeten worden"},on:{"input":_vm.update}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }